import React from 'react';
import {createStackNavigator, StackHeaderProps} from '@react-navigation/stack';

import BrandHeader from '../components/BrandHeader';
import {AppRoute} from '../models/AppRoute';
import {HeaderConfig} from '../models/navigationTypes';
import {RootStoreSelectionFlowParamList} from '../models/navigationTypes';
import {
  GIFT_CARDS_OPTIONS,
  GIFT_CARDS_TERMS_AND_CONDITIONS,
  STORE_NAME,
  STORE_SELECTION,
} from '../screens/constants';
import GiftCardsPromotionDetailRootFlowScreen from '../screens/giftCards/GiftCardsPromotionDetailRootFlowScreen';
import GiftCardsTermsAndConditionsScreen from '../screens/giftCards/GiftCardsTermsAndConditions';
import StoreSelectionScreen from '../screens/storeSelection/StoreSelectionScreen';
import SuburbSelectionScreen from '../screens/storeSelection/SuburbSelectionScreen';

import useCommonScreenOptions from './hooks/useCommonScreenOptions';

export const header =
  (config: HeaderConfig) =>
  ({navigation, route}: StackHeaderProps) =>
    <BrandHeader navigation={navigation} route={route} config={config} />;

const Stack = createStackNavigator<RootStoreSelectionFlowParamList>();

const RootStoreSelectionFlowStackNavigator = () => {
  const commonScreenOptions = useCommonScreenOptions(true);

  return (
    <Stack.Navigator screenOptions={commonScreenOptions}>
      <Stack.Screen
        name={AppRoute.MY_STORE_SUBURB_SELECTION}
        component={SuburbSelectionScreen}
        options={{
          header: header({
            back: false,
            shop: true,
            filter: false,
            burger: false,
            search: false,
            source: STORE_NAME,
          }),
        }}
      />
      <Stack.Screen
        name={AppRoute.MY_STORE_STORE_SELECTION}
        component={StoreSelectionScreen}
        options={{
          header: header({
            back: true,
            shop: false,
            filter: false,
            burger: false,
            search: false,
            source: STORE_SELECTION,
          }),
        }}
      />
      {/* These screens are here because we needed a quick solution to show 
      the Gift Card Promotion Details screen without the need to select a store. */}
      <Stack.Screen
        name={AppRoute.ROOT_GIFT_CARDS_PROMOTION}
        component={GiftCardsPromotionDetailRootFlowScreen}
        options={{
          header: header({
            back: true,
            shop: false,
            filter: false,
            burger: false,
            search: false,
            source: GIFT_CARDS_OPTIONS,
          }),
        }}
      />
      <Stack.Screen
        name={AppRoute.ROOT_GIFT_CARDS_TERMS_AND_CONDITIONS}
        component={GiftCardsTermsAndConditionsScreen}
        options={{
          header: header({
            back: true,
            shop: false,
            filter: false,
            burger: false,
            search: false,
            source: GIFT_CARDS_TERMS_AND_CONDITIONS,
          }),
        }}
      />
    </Stack.Navigator>
  );
};

export default RootStoreSelectionFlowStackNavigator;
